package one.healthium.onboarding.ui.screens

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import one.healthium.bundle.components.BundleImage
import one.healthium.onboarding.domain.configs.CongratsScreenConfig
import one.healthium.onboarding.ui.UserDataProvider
import one.healthium.onboarding.ui.UserProfileUiModel
import one.healthium.onboarding.ui.bindPlaceholderValues
import one.healthium.ui.common.utils.toColor
import one.healthium.ui.common.utils.toPaddingValues
import one.healthium.ui.common.utils.toTextAlign
import one.healthium.ui.components.CtaButton
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.theme.AppTheme

interface CongratsEventDelegate {
    fun onNextClicked()
}

@Composable
internal fun CongratsScreen(
    eventDelegate: CongratsEventDelegate,
    screenConfig: CongratsScreenConfig,
) {
    UserDataProvider { userState, _ ->
        CongratsScreenContent(
            screenConfig = screenConfig,
            userState = userState,
            onNextClicked = eventDelegate::onNextClicked,
        )
    }
}

@Composable
private fun CongratsScreenContent(
    modifier: Modifier = Modifier,
    screenConfig: CongratsScreenConfig,
    userState: UserProfileUiModel,
    onNextClicked: () -> Unit,
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .background(screenConfig.backgroundColor?.toColor() ?: AppTheme.colors.windowBackground)
            .navigationBarsPadding()
            .verticalScroll(rememberScrollState()),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        if (screenConfig.image == null) {
            Spacer(Modifier.statusBarsPadding())
        } else {
            BundleImage(
                modifier = Modifier
                    .fillMaxWidth()
                    .then(if (screenConfig.imageSafeAreaTop == true) Modifier.statusBarsPadding() else Modifier)
                    .padding(screenConfig.imageInsets.toPaddingValues()),
                name = screenConfig.image,
                contentScale = ContentScale.Crop,
            )
        }

        Spacer(Modifier.height(24.dp))

        val textAlign = screenConfig.textAlign.toTextAlign() ?: TextAlign.Center
        if (textAlign == TextAlign.Center) {
            Spacer(Modifier.weight(0.5f))
        }

        AppText(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp),
            text = screenConfig.title?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.titleLarge,
            color = AppTheme.colors.textInverted100,
            textAlign = textAlign,
        )
        Spacer(Modifier.height(16.dp))
        AppText(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp),
            text = screenConfig.subtitle?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.subTitleLarge,
            color = AppTheme.colors.textInverted100,
            textAlign = textAlign,
        )
        Spacer(Modifier.height(24.dp))
        Spacer(Modifier.weight(1f))
        CtaButton(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 38.dp),
            text = screenConfig.ctaTitle,
            onClick = onNextClicked,
        )
        Spacer(Modifier.height(24.dp))
    }
}
